import { BaseService, Service } from "/@/cool";
@Service("dealerShopSetting")
class DealerShopSetting extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["templateList"] = prefix + "templateList";
		this.permission["getDealerVersionId"] = prefix + "getDealerVersionId";
		this.permission["settleCateProductList"] = prefix + "settleCateProductList";
		this.permission["commonSettleInfo"] = prefix + "commonSettleInfo";
		this.permission["relateShopList"] = prefix + "relateShopList";
		this.permission["cateProductList"] = prefix + "cateProductList";
		this.permission["saveSkuPrice"] = prefix + "saveSkuPrice";
		this.permission["versionInfo"] = prefix + "versionInfo";
		this.permission["save"] = prefix + "save";
		this.permission["saveAs"] = prefix + "saveAs";
		this.permission["saveSettingSku"] = prefix + "saveSettingSku";
		this.permission["skuConfig"] = prefix + "skuConfig";
		this.permission["settleInfo"] = prefix + "settleInfo";
		this.permission["settleUpdate"] = prefix + "settleUpdate";
		this.permission["shopList"] = prefix + "shopList";
		this.permission["shopListUnconfigured"] = prefix + "shopListUnconfigured";
		this.permission["productPage"] = prefix + "productPage";
		this.permission["productInfo"] = prefix + "productInfo";
		this.permission["bodiesList"] = prefix + "bodiesList";
		this.permission["cateList"] = prefix + "cateList";
		this.permission["addRelateDealer"] = prefix + "addRelateDealer";
		this.permission["addRelateShop"] = prefix + "addRelateShop";
		this.permission["commonSettleUpdate"] = prefix + "commonSettleUpdate";
		this.permission["templateList"] = prefix + "templateList";
		this.permission["versionList"] = prefix + "versionList";
		this.permission["unbind"] = prefix + "unbind";
		this.permission["versionInfoForSettle"] = prefix + "versionInfoForSettle";
		this.permission["updateRelateShop"] = prefix + "updateRelateShop";
		this.permission["shopUpToSettleVersionBind"] = prefix + "shopUpToSettleVersionBind";
	}

	// 添加门店配置
	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}

	// 更新门店配置
	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	// 获取门店配置
	info(params: any) {
		return this.request({
			url: "/info",
			method: "GET",
			params
		});
	}

	// 获取经销商下的门店配置列表
	list(params: any) {
		return this.request({
			url: "/list",
			method: "GET",
			params
		});
	}

	// 解除绑定门店配置
	unbind(data: any) {
		return this.request({
			url: "/unbind",
			method: "POST",
			data
		});
	}

	// 获取经销商下的门店列表
	shopList(params: any) {
		return this.request({
			url: "/shopList",
			method: "GET",
			params
		});
	}

	// 获取未配置的门店列表
	shopListUnconfigured(params: any) {
		return this.request({
			url: "/shopListUnconfigured",
			method: "GET",
			params
		});
	}

	// 更新门店结算设置
	settleUpdate(data: any) {
		return this.request({
			url: "/settleUpdate",
			method: "POST",
			data
		});
	}

	// 获取门店结算设置信息
	settleInfo(params: any) {
		return this.request({
			url: "/settleInfo",
			method: "GET",
			params
		});
	}

	// 获取门店SKU配置信息
	skuConfig(params: any) {
		return this.request({
			url: "/skuConfig",
			method: "GET",
			params
		});
	}

	// 保存结算版本SKU设置
	saveSettingSku(data: any) {
		return this.request({
			url: "/saveSettingSku",
			method: "POST",
			data
		});
	}

	// 保存门店SKU设置
	saveSkuPrice(data: any) {
		return this.request({
			url: "/saveSkuPrice",
			method: "POST",
			data
		});
	}

	// 产品管理分页查询
	productPage(params: any) {
		return this.request({
			url: "/productPage",
			method: "GET",
			params
		});
	}

	// 获取产品信息
	productInfo(params: any) {
		return this.request({
			url: "/productInfo",
			method: "GET",
			params
		});
	}

	// 获取产品主体列表
	bodiesList(params: any) {
		return this.request({
			url: "/bodiesList",
			method: "GET",
			params
		});
	}

	// 获取产品分类列表
	cateList(params: any) {
		return this.request({
			url: "/cateList",
			method: "GET",
			params
		});
	}

	// 获取分类及其下的产品列表
	cateProductList(params: any) {
		return this.request({
			url: "/cateProductList",
			method: "GET",
			params
		});
	}

	// 获取分类及其下的产品列表
	settleCateProductList(params: any) {
		return this.request({
			url: "/settleCateProductList",
			method: "GET",
			params
		});
	}

	// 绑定待绑定门店
	addRelateDealer(data: any) {
		return this.request({
			url: "/addRelateDealer",
			method: "POST",
			data
		});
	}

	// 添加关联门店
	addRelateShop(data: any) {
		return this.request({
			url: "/addRelateShop",
			method: "POST",
			data
		});
	}

	// 获取通用配置
	commonSettleInfo(params: any) {
		return this.request({
			url: "/commonSettleInfo",
			method: "GET",
			params
		});
	}

	// 更新通用配置
	commonSettleUpdate(data: any) {
		return this.request({
			url: "/commonSettleUpdate",
			method: "POST",
			data
		});
	}

	//
	templateList(params: any) {
		return this.request({
			url: "/templateList",
			method: "GET",
			params
		});
	}

	// 获取门店SKU配置信息
	versionInfo(params: any) {
		return this.request({
			url: "/versionInfo",
			method: "GET",
			params
		});
	}

	// 保存模板
	save(data: any) {
		return this.request({
			url: "/save",
			method: "POST",
			data
		});
	}

	// 另存为模板
	saveAs(data: any) {
		return this.request({
			url: "/saveAs",
			method: "POST",
			data
		});
	}

	// 获取关联门店列表
	relateShopList(params: any) {
		return this.request({
			url: "/relateShopList",
			method: "GET",
			params
		});
	}

	//获取经销商版本
	getDealerVersionId(params: any) {
		return this.request({
			url: "/getDealerVersionId",
			method: "GET",
			params
		});
	}

	// 获取经销商版本信息
	versionInfoForSettle(params: any) {
		return this.request({
			url: "/versionInfoForSettle",
			method: "GET",
			params
		});
	}

	// 更新关联门店
	shopUpToSettleVersionBind(data: any) {
		return this.request({
			url: "/shopUpToSettleVersionBind",
			method: "POST",
			data
		});
	}
}
export default DealerShopSetting;
